import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function CTAButton() {
  const handleClick = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <motion.button onClick={handleClick} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className="bg-amber-cta hover:bg-amber-cta/90 text-white font-bold text-lg px-8 py-4 rounded-lg shadow-[0_0_20px_rgba(255,77,0,0.3)] hover:shadow-[0_0_30px_rgba(255,77,0,0.5)] inline-flex items-center gap-3 transition-all" data-id="element-1">
      DOWNLOAD MY BIOLOGICAL MAP NOW
      <ArrowRightIcon className="w-5 h-5" data-id="element-2" />
    </motion.button>;
}